import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a68e5dda875aa0014748aed_1785326163115_a8667a15/opsivo/src/app/goods-issuance-management/components/GIContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a68e5dda875aa0014748aed_1785326163115_a8667a15/opsivo/src/components/AppLayout.tsx");
